import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { SCHEDULE_RANGE_OPTIONS } from "../utils/dateRangeUtils";

export function ScheduleRangeSelector({ value, onChange, disabled }) {
  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={value}
      onChange={(event, nextValue) => {
        if (nextValue) {
          onChange(nextValue);
        }
      }}
      disabled={disabled}
      aria-label="Schedule range"
    >
      {SCHEDULE_RANGE_OPTIONS.map((option) => (
        <ToggleButton key={option.days} value={option.days}>
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
